import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
var defaultDialogProps = {
  hidden: true,
  handleStay: function handleStay() {},
  handleLeave: function handleLeave() {}
};
/**
 * Should be only used by RouteBlocker component and global methods defined in RouteBlocker.tsx.
 */

export var RouteBlockerStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(RouteBlockerStore, _BaseStore);

  function RouteBlockerStore() {
    var _this;

    _classCallCheck(this, RouteBlockerStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RouteBlockerStore).apply(this, arguments));
    _this.name = StoreName.RouteBlocker;
    _this.blockNavigationWithModal = false;
    _this.modalTitle = '';
    _this.modalBody = '';
    _this.dialogProps = defaultDialogProps;

    _this.setBlockNavigationWithModal = function (value) {
      var where = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      _this.blockNavigationWithModal = value;
    };

    return _this;
  }

  _createClass(RouteBlockerStore, [{
    key: "setModalTitle",
    value: function setModalTitle(value) {
      this.modalTitle = value;
    }
  }, {
    key: "setModalBody",
    value: function setModalBody(value) {
      this.modalBody = value;
    }
  }, {
    key: "handleNavigationAttempt",
    value: function handleNavigationAttempt(navigation
    /*, location, action*/
    ) {
      var _this2 = this;

      if (!this.blockNavigationWithModal) {
        navigation.resume();
      } // this is temporary solution since tabs will be reworked in near future, after rework this code should be deleted


      var toLocation = location.pathname.split('/');
      var tabs = ['history', 'products', 'detail', 'documents', 'kpi', 'edit'];

      if (toLocation.includes('windows') || toLocation.includes('promotions')) {
        if (tabs.some(function (item) {
          return toLocation.includes(item);
        })) {
          navigation.resume();
          this.setBlockNavigationWithModal(false);
          return null;
        }
      }

      this.dialogProps = {
        hidden: false,
        handleStay: function handleStay() {
          _this2.closeDialog();

          navigation.cancel();
        },
        handleLeave: function handleLeave() {
          _this2.closeDialog();

          navigation.resume();

          _this2.setBlockNavigationWithModal(false);
        }
      }; // returning null will pause navigation

      return null;
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.dialogProps = defaultDialogProps;
    }
  }, {
    key: "simulateNavigation",
    value: function simulateNavigation() {
      var _this3 = this;

      if (!this.blockNavigationWithModal) {
        // simply allow, when navigation isn't blocked
        return Promise.resolve();
      }

      if (!this.dialogProps.hidden) {
        // calling simulateNavigation, while navigating - that would be problem
        return Promise.reject(new Error('Cannot block navigation when already blocked.'));
      }

      return new Promise(function (resolve, reject) {
        _this3.dialogProps = {
          hidden: false,
          handleStay: function handleStay() {
            _this3.closeDialog();

            reject(new Error('Navigation blocked by user.'));
          },
          handleLeave: function handleLeave() {
            _this3.closeDialog();

            resolve();

            _this3.setBlockNavigationWithModal(false);
          }
        };
      });
    }
  }, {
    key: "shouldBlockNavigationWithModal",
    get: function get() {
      return this.blockNavigationWithModal;
    }
  }]);

  return RouteBlockerStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Object)], RouteBlockerStore.prototype, "blockNavigationWithModal", void 0);

__decorate([observable, __metadata("design:type", Object)], RouteBlockerStore.prototype, "modalTitle", void 0);

__decorate([observable, __metadata("design:type", Object)], RouteBlockerStore.prototype, "modalBody", void 0);

__decorate([observable, __metadata("design:type", Object)], RouteBlockerStore.prototype, "dialogProps", void 0);

__decorate([action, __metadata("design:type", Object)], RouteBlockerStore.prototype, "setBlockNavigationWithModal", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], RouteBlockerStore.prototype, "setModalTitle", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], RouteBlockerStore.prototype, "setModalBody", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], RouteBlockerStore.prototype, "handleNavigationAttempt", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], RouteBlockerStore.prototype, "closeDialog", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], RouteBlockerStore.prototype, "simulateNavigation", null);